import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import dealerAction from "../../redux/dealer/actions";
import manualAddFundAction from "../../redux/manualAddFund/actions";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/utils/Alert";
import authAction from "../../redux/auth/actions";
import Select from "react-select";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import Button from "../../components/utils/Button";

function ManualAddFund() {
  const { getDealer } = dealerAction;
  const { getUserDataByToken } = authAction;
  const { manualAddFund, resetManualAddFund } = manualAddFundAction;
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState("");
  const [addFormData, setAddFormData] = useState({
    dealerID: "",
    amount: "",
    remarks: "",
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: addFormData,
  });

  const enteredAmount = watch("amount");

  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const successMessage = useSelector(
    (state) => state.manualAddFund.manualAddFundMessage,
  );
  const errorMessage = useSelector(
    (state) => state.manualAddFund.manualAddFundError,
  );
  const updateTopUpFlag = useSelector(
    (state) => state.manualAddFund.updateManualTopUpFlag,
  );
  const { loading: buttonLoading } = useSelector(
    (state) => state.manualAddFund,
  );
  const [dealerAmountToShow, setDealerAmountToShow] = useState("0");
  const [dealerName, setDealerName] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [firstChar, setFirstChar] = useState("");
  const [errorMessageForm, setErrorMessageForm] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [selectedDealer, setSelectedDealer] = useState(null);

  const defaultOption = { label: "Select", value: "" };

  useEffect(() => {
    dispatch(getDealer());
  }, [successMessage]);

  useEffect(() => {
    dispatch(getUserDataByToken());
    dispatch(getDealer());
    setDealerAmountToShow("0");
    dispatch(getDealer());
  }, [updateTopUpFlag]);

  useEffect(() => {
    reset(addFormData);
  }, [addFormData]);

  useEffect(() => {
    if (errorMessage !== null && errorMessage !== undefined) {
      displayAlert(errorMessage, "alert-danger");
    }
    if (successMessage !== null && successMessage !== undefined) {
      displayAlert(successMessage, "alert-success");
      setAddFormData((prev) => ({
        ...prev,
        dealerID: "",
        amount: "",
        remarks: "",
      }));
      setDealerAmountToShow("0");
    }
  }, [errorMessage, successMessage]);

  const handleChange = (selectedOption) => {
    clearErrors(["dealerID"]);
    if (selectedOption) {
      const selectedDealer = dealerResult.find(
        (dealer) => dealer.ID === selectedOption.value,
      );
      setValue("dealerID", [selectedOption.value]);
      setSelectedDealer(selectedDealer);
      setDealerAmountToShow(selectedDealer && selectedDealer.AccountBalance);
      setDealerName(selectedDealer && selectedDealer.DealerName);
      const [firstName] =
        selectedDealer && selectedDealer.DealerName.split(" ");
      if (firstName) {
        const initials = firstName.charAt(0);
        setFirstChar(initials);
      }
      setDealerId(selectedOption.value);
    }
  };

  const handleNumber = (e) => {
    const { value } = e.target;
    if (
      !(
        e.shiftKey ||
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode === 8 ||
        e.keyCode === 190 ||
        e.keyCode === 110
      )
    ) {
      e.preventDefault();
    }
    if ((e.keyCode === 190 || e.keyCode === 110) && value.includes(".")) {
      e.preventDefault();
    }
    if (value.includes(".")) {
      const parts = value.split(".");
      if (parts[1].length >= 2 && e.keyCode !== 8) {
        e.preventDefault();
      }
    }
  };

  const handleAmountChange = (e) => {
    setErrorMessageForm("");
    clearErrors(["amount"]);
  };

  const handleSelectFundType = (fundTypeValue) => {
    if (dealerId === "") {
      setError("dealerID", {
        type: {
          required: "Dealer required",
        },
      });
      return false;
    }

    const data = watch();
    const amount = Number(data.amount);
    if (
      (fundTypeValue === 1 || fundTypeValue === 2) &&
      !isNaN(amount) &&
      amount !== 0 &&
      Math.abs(amount) <= 99999 &&
      data.remarks !== ""
    ) {
      const submitDealerFund = {
        dealerId: dealerId,
        amount: amount,
        fundType: fundTypeValue,
        remarks: data.remarks,
      };
      dispatch(manualAddFund(submitDealerFund));
    } else {
      setErrorMessageForm("Invalid amount.");
    }
  };

  const displayAlert = (text, type) => {
    reset({
      dealerID: "",
    });
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetManualAddFund());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
    dispatch(resetManualAddFund());
  };

  const options = dealerResult
    .filter((dealer) => dealer.ParentID !== 0)
    .map((dealer) => ({
      label: dealer.DealerName,
      value: dealer.ID,
    }));

  return (
    <div id="content-page" className="content-page">
      <div className="container-fluid">
        <div className="afh-page">
          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-11 col-md-12">
              {showAlert && (
                <Alert
                  type={alertType}
                  text={alertText}
                  closeBtn={alertCancel}
                />
              )}
              <form onSubmit={handleSubmit(handleSelectFundType)}>
                <div className="afh-card">
                  {/* Left panel: dealer + balance */}
                  <div className="afh-left">
                    <div>
                      <h1 className="afh-title">Add Fund</h1>
                      <p className="afh-subtitle">
                        Top up or deduct a dealer's balance
                      </p>
                    </div>

                    <div className="afh-select select-bar-manul-add-fund">
                      <div className="afh-step">
                        <span className="afh-step-no">1</span>
                        Choose dealer
                      </div>
                      <Controller
                        control={control}
                        defaultValue={options.map((c) => c.value)}
                        name="dealerID"
                        rules={{ required: true }}
                        render={({ field: { onChange, value, ref } }) => (
                          <Select
                            className="basic-single"
                            placeholder={"Select dealer.."}
                            value={options.filter((c) =>
                              value.includes(c.value),
                            )}
                            onChange={handleChange}
                            options={options}
                            isSearchable={true}
                          />
                        )}
                      />
                      {errors.dealerID && (
                        <div className="afh-error">Please Select dealer !</div>
                      )}
                    </div>

                    <div className="afh-dealer">
                      <div className="afh-avatar">
                        <p>{firstChar}</p>
                      </div>
                      <p className="afh-dealer-name">{dealerName}</p>
                    </div>

                    <div className="afh-balance">
                      <h2 className="afh-balance-title">Current balance</h2>
                      <div className="afh-balance-value">
                        <span className="afh-currency">$</span>
                        <span>{twoDigitDecimal(dealerAmountToShow)}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right panel: amount + remark + actions */}
                  <div className="afh-right">
                    <form>
                      <div>
                        <label className="afh-step" htmlFor="afh-amount">
                          <span className="afh-step-no">2</span>
                          Enter amount
                        </label>
                        <div className="afh-amount-wrap">
                          <span className="afh-amount-symbol">$</span>
                          <input
                            id="afh-amount"
                            className="afh-amount-input"
                            type="number"
                            name="amount"
                            placeholder="00.00"
                            {...register("amount", {
                              required: true,
                              min: 0.01,
                              max: 99999,
                            })}
                            onChange={handleAmountChange}
                            onKeyDown={handleNumber}
                          />
                        </div>
                        <p className="afh-hint">
                          Maximum $99,999 per transaction
                        </p>
                        {errorMessageForm && (
                          <div className="afh-error">{errorMessageForm}</div>
                        )}
                        {errors.amount?.type === "required" && (
                          <div className="afh-error">Amount is required !</div>
                        )}
                        {errors.amount?.type === "min" && (
                          <div className="afh-error">
                            Amount must be greater than zero!
                          </div>
                        )}
                        {errors.amount?.type === "max" && (
                          <div className="afh-error">
                            Amount must be less than 99999!
                          </div>
                        )}
                      </div>

                      <div className="afh-remark">
                        <label className="afh-step" htmlFor="afh-remark">
                          <span className="afh-step-no">3</span>
                          Add a remark
                        </label>
                        <input
                          id="afh-remark"
                          type="text"
                          className="form-control"
                          placeholder="Remark"
                          name="remarks"
                          {...register("remarks", {
                            required: true,
                          })}
                        />
                        {errors.remarks?.type === "required" && (
                          <div className="afh-error">Remark is required !</div>
                        )}
                      </div>
                    </form>

                    <div className="afh-actions">
                      <div>
                        <Button
                          title={"Deduct"}
                          onClick={() => handleSelectFundType(2)}
                          buttonClass="afh-btn-deduct"
                          loading={buttonLoading}
                          buttonType="submit"
                        />
                      </div>
                      <div>
                        <Button
                          title={"Add Top Up"}
                          onClick={() => handleSelectFundType(1)}
                          buttonClass="afh-btn-add"
                          loading={buttonLoading}
                          buttonType="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManualAddFund;
